<template>
    <AppLayout title="Simulador">
        <Toast />
        <Breadcrumb route="simulador" page="Simulador" />
        <form class="p-2">
            <div class="font-medium text-gray-600 text-xl mb-4">
                Datos
            </div>
            <div class="flex flex-col">
                <div class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2">
                    <div class="w-full h-24">
                        <label for="cp_origen" class="my-1 text-gray-700">
                            Cp de Origen<span class="text-red-400">*</span>
                        </label>
                        <select
                            id="cp_origen"
                            class="t-select"
                            v-model="form.cp_origen"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="cpO in cpOrigen"
                                :value="cpO.cp"
                                :key="cpO.cp"
                            >
                                {{ '('+cpO.cp+') - ' + cpO.localidad }}
                            </option>
                        </select>
                        <small
                            v-if="form.errors.cp_origen"
                            id="cp_origen-help"
                            class="p-error"
                        >
                            {{ form.errors.cp_origen }}
                        </small>
                    </div>
                    <div class="w-full h-24">
                        <label for="cp_destino" class="my-1 text-gray-700">
                            Cp de Destino<span class="text-red-400">*</span>
                        </label>
                        <select
                            id="cp_destino"
                            class="t-select"
                            v-model="form.cp_destino"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="cpD in cpDestino"
                                :value="cpD.cp"
                                :key="cpD.cp"
                            >
                                {{ '('+cpD.cp+') - ' + cpD.localidad }}
                            </option>
                        </select>
                        <small
                            v-if="form.errors.cp_destino"
                            id="cp_destino-help"
                            class="p-error"
                        >
                            {{ form.errors.cp_destino }}
                        </small>
                    </div>
                    <div class="w-full h-24">
                        <label for="cantidad" class="my-1 text-gray-700">
                            Cantidad<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="cantidad"
                            :class="[
                                't-input',
                                form.errors.cantidad && 't-input-invalid',
                            ]"
                            v-model="form.cantidad"
                            placeholder="ej. 1"
                        />
                        <small
                            v-if="form.errors.cantidad"
                            id="cantidad-help"
                            class="p-error"
                        >
                            {{ form.errors.cantidad }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="flex flex-col">
                <div class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2">
                    <div class="w-full h-24">
                        <label for="peso" class="my-1 text-gray-700">
                            Peso (Kg.)<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="peso"
                            :class="[
                                't-input',
                                form.errors.peso && 't-input-invalid',
                            ]"
                            v-model="form.peso"
                            placeholder="ej. 1.2"
                        />
                        <small
                            v-if="form.errors.peso"
                            id="peso-help"
                            class="p-error"
                        >
                            {{ form.errors.peso }}
                        </small>
                    </div>
                    <div class="w-full h-24">
                        <label for="alto" class="my-1 text-gray-700">
                            Alto (cm.)<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="alto"
                            :class="[
                                't-input',
                                form.errors.alto && 't-input-invalid',
                            ]"
                            v-model="form.alto"
                            placeholder="ej. 10"
                        />
                        <small
                            v-if="form.errors.alto"
                            id="alto-help"
                            class="p-error"
                        >
                            {{ form.errors.alto }}
                        </small>
                    </div>
                    <div class="w-full h-24">
                        <label for="largo" class="my-1 text-gray-700">
                            Largo (cm.)<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="largo"
                            :class="[
                                't-input',
                                form.errors.largo && 't-input-invalid',
                            ]"
                            v-model="form.largo"
                            placeholder="ej. 10"
                        />
                        <small
                            v-if="form.errors.largo"
                            id="largo-help"
                            class="p-error"
                        >
                            {{ form.errors.largo }}
                        </small>
                    </div>
                    <div class="w-full h-24">
                        <label for="ancho" class="my-1 text-gray-700">
                            Ancho (cm.)<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="ancho"
                            :class="[
                                't-input',
                                form.errors.ancho && 't-input-invalid',
                            ]"
                            v-model="form.ancho"
                            placeholder="ej. 10"
                        />
                        <small
                            v-if="form.errors.ancho"
                            id="ancho-help"
                            class="p-error"
                        >
                            {{ form.errors.ancho }}
                        </small>
                    </div>   
                </div>
             </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="simular"> Simular </Button>
            </div>
        </form>
        <div v-show="servicios !== undefined">
            <table class="table-auto w-full">
                <thead class="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                    <tr>
                        <th class="p-2 whitespace-nowrap">
                            <div class="font-semibold text-left">Proveedor</div>
                        </th>
                        <th class="p-2 whitespace-nowrap">
                            <div class="font-semibold text-left">Tipo de Entrega</div>
                        </th>
                        <th class="p-2 whitespace-nowrap">
                            <div class="font-semibold text-left">Servicio</div>
                        </th>
                        <th class="p-2 whitespace-nowrap">
                            <div class="font-semibold text-left">Precio</div>
                        </th>
                    </tr>
                </thead>
                <tbody class="text-sm divide-y divide-gray-100">
                    <tr v-for="servicio in servicios" :key="servicio.id">
                        <td class="p-2 whitespace-nowrap">
                            <div class="font-medium text-gray-800">{{servicio.proveedor}}</div>
                        </td>
                        <td class="p-2 whitespace-nowrap">
                            <div class="font-medium text-gray-800">{{servicio.tipo_entrega}}</div>
                        </td>
                        <td class="p-2 whitespace-nowrap">
                            <div class="font-medium text-gray-800">{{servicio.servicio}}</div>
                        </td>
                        <td class="p-2 whitespace-nowrap">
                            <div class="font-medium text-gray-800">{{servicio.precio}}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </AppLayout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        cpOrigen: Array,
        cpDestino: Array,
        cpSucursal: Array,
        servicios: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                cp_origen: this.cpSucursal.cp,
                cp_destino: null,
                peso: null,
                alto: null,
                largo: null,
                ancho: null,
                cantidad: null
            }),
        };
    },
    methods: {
        simular() {
            this.form.post("/simular", {
                onSuccess: () => {
                    console.log(this.servicios);
                    if(this.servicios.length !== 0){
                        this.$toast.add({
                            severity: "success",
                            summary: "Exito",
                            detail: "Simulación Realizada!",
                            life: 3000,
                        });
                    }
                    if(this.servicios.length === 0){
                        this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Simulación Fallida, Intenta Nuevamente!",
                        life: 3000,
                        });
                    }
                },
            });
        }
    }
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>